import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["addButton", "addMoreButton", "modal", "rows"]

  connect() {
    this.allowNextSubmit = false
    this.submitAfterHide = false
    this.boundHandleHidden = this.handleHidden.bind(this)
    this.boundPrepareForCache = this.prepareForCache.bind(this)
    this.modalInstance = Modal.getOrCreateInstance(this.modalTarget)
    this.modalTarget.addEventListener("hidden.bs.modal", this.boundHandleHidden)
    document.addEventListener("turbo:before-cache", this.boundPrepareForCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.boundPrepareForCache)
    this.modalTarget.removeEventListener("hidden.bs.modal", this.boundHandleHidden)
    this.resetPendingAction()
    this.modalInstance?.hide()
    this.modalInstance?.dispose()
  }

  confirm(event) {
    if (event.defaultPrevented) {
      this.allowNextSubmit = false
      return
    }

    if (this.allowNextSubmit) {
      this.allowNextSubmit = false
      return
    }

    if (this.filledEmployeeCount !== 1) return

    event.preventDefault()
    this.submitter = event.submitter
    this.focusAfterHide = event.submitter
    this.modalTarget.addEventListener("shown.bs.modal", () => this.addMoreButtonTarget.focus(), { once: true })
    this.modalInstance.show()
  }

  addMore() {
    this.focusAfterHide = this.addButtonTarget
    this.modalInstance.hide()
  }

  submit() {
    this.submitAfterHide = true
    this.focusAfterHide = null
    this.modalInstance.hide()
  }

  prepareForCache() {
    this.resetPendingAction()
    this.modalInstance.hide()
  }

  handleHidden() {
    if (this.submitAfterHide) {
      const submitter = this.submitter

      this.submitAfterHide = false
      this.submitter = null
      this.allowNextSubmit = true

      if (submitter?.isConnected) {
        this.element.requestSubmit(submitter)
      } else {
        this.element.requestSubmit()
      }

      this.allowNextSubmit = false
      return
    }

    const focusTarget = this.focusAfterHide
    this.focusAfterHide = null
    window.setTimeout(() => focusTarget?.focus(), 0)
  }

  get filledEmployeeCount() {
    return Array.from(this.rowsTarget.querySelectorAll("[data-employee-select]"))
      .filter((field) => field.value).length
  }

  resetPendingAction() {
    this.allowNextSubmit = false
    this.submitAfterHide = false
    this.submitter = null
    this.focusAfterHide = null
  }
}
